<div class="css-variables-editor" [formGroup]="form">
  <div formArrayName="variables">
    @for (variableGroup of variablesFormArray.controls; track variableGroup; let i = $index) {
      <div [formGroupName]="i"
        class="variable-row">
        <div class="row mb-2">
          <div class="col-sm-5">
            <mat-form-field>
              <mat-label>CSS Variable</mat-label>
              <mat-select formControlName="variable">
                <!-- Group by category -->
                <mat-optgroup label="Colors">
                  @for (variable of getFilteredVariables('Colors', i); track variable) {
                    <mat-option [value]="variable.variable">
                      {{ variable.displayName }}
                    </mat-option>
                  }
                </mat-optgroup>
                <mat-optgroup label="Layout">
                  @for (variable of getFilteredVariables('Layout', i); track variable) {
                    <mat-option [value]="variable.variable">
                      {{ variable.displayName }}
                    </mat-option>
                  }
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-sm-5">
            <mat-form-field>
              <mat-label>Value</mat-label>
              <input matInput formControlName="value"
                [placeholder]="getPlaceholder(variableGroup.get('variable')?.value)">
            </mat-form-field>
          </div>
          <div class="col-sm-2">
            <button mat-icon-button color="warn" type="button" (click)="removeVariableRow(i)"
              aria-label="Remove variable">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
        <!-- Color preview for color variables -->
        @if (variableGroup.get('variable')?.value?.includes('color')) {
          <div class="row">
            <div class="col-sm-5 offset-sm-5">
              <div class="color-preview" [style.background-color]="variableGroup.get('value')?.value"></div>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="row mt-2">
    <div class="col-sm-12">
      <button mat-stroked-button color="primary" type="button" (click)="addVariableRow()">
        <mat-icon>add</mat-icon>
        Add CSS Variable
      </button>
    </div>
  </div>
</div>
